export const common = {
  // Navigation
  home: 'Início',
  services: 'Serviços',
  about: 'Sobre Nós',
  gallery: 'Galeria',
  contact: 'Contato',
  reserve: 'Reservar',
  
  // Buttons
  bookNow: 'Reserve Agora',
  learnMore: 'Saiba mais',
  whatsapp: 'WhatsApp',
  close: 'Fechar',
  
  // Hero Section
  heroTitle: 'Viaje com',
  heroTitleHighlight: 'Elegância',
  heroDescription: 'Descubra o Marrocos e o Canadá de forma diferente com nosso serviço de transporte premium. Conforto, segurança e hospitalidade autêntica.',
  
  // Services
  servicesTitle: 'Nossos Serviços Premium',
  servicesDescription: 'Uma gama completa de serviços de transporte turístico para atender todas as suas necessidades de viagem, desde transferências simples até os circuitos mais exclusivos.',
  
  // About
  aboutTitle: 'Nossa História',
  aboutDescription1: 'Há mais de 10 anos, oferecemos uma experiência excepcional de transporte turístico no Marrocos e no Canadá. Nossa paixão pela hospitalidade marroquina e nossa expertise do terreno nos permitem criar viagens inesquecíveis.',
  aboutDescription2: 'Seja você um viajante de negócios, uma família de férias ou um grupo de amigos em busca de aventura, colocamos nosso know-how ao seu serviço para que cada quilômetro seja um prazer.',
  
  // Values
  security: 'Segurança',
  securityDesc: 'Veículos mantidos e motoristas certificados para sua tranquilidade.',
  punctuality: 'Pontualidade',
  punctualityDesc: 'Respeito aos horários e compromissos para um serviço confiável.',
  hospitality: 'Hospitalidade',
  hospitalityDesc: 'Recepção calorosa e serviço personalizado na tradição marroquina.',
  excellence: 'Excelência',
  excellenceDesc: 'Busca constante da perfeição em cada detalhe de nossos serviços.',
  
  // Testimonials
  testimonialsTitle: 'Depoimentos de Clientes',
  testimonialsDescription: 'Descubra o que nossos clientes dizem sobre sua experiência com nosso serviço de transporte premium.',
  satisfiedClients: 'Clientes Satisfeitos',
  destinations: 'Destinos',
  customerService: 'Atendimento ao Cliente',
  
  // Reservation
  reservationTitle: 'Reserve Seu Transporte',
  reservationDescription: 'Preencha o formulário abaixo para obter um orçamento personalizado ou reserve diretamente seu serviço de transporte premium.',
  fullName: 'Nome completo',
  email: 'E-mail',
  phone: 'Telefone',
  desiredService: 'Serviço desejado',
  selectService: 'Selecione um serviço',
  departureDate: 'Data de partida',
  departureTime: 'Hora de partida',
  passengers: 'Passageiros',
  passenger: 'passageiro',
  departureLocation: 'Local de partida',
  destination: 'Destino',
  message: 'Mensagem ou solicitações especiais',
  messageDescription: 'Descreva suas necessidades específicas, preferências ou perguntas...',
  sendRequest: 'Enviar solicitação',
  sending: 'Enviando...',
  directContact: 'Contato Direto',
  availability: 'Disponibilidade',
  quickResponse: 'Resposta Rápida',
  quickResponseDescription: 'Comprometemo-nos a responder o mais breve possível:',
  whatsappResponse: 'WhatsApp: Resposta imediata',
  emailResponse: 'E-mail: Em até 2 horas',
  freeQuote: 'Orçamento gratuito e sem compromisso',
  
  // Contact
  contactTitle: 'Entre em Contato',
  contactDescription: 'Nossa equipe está à sua disposição para responder todas as suas perguntas e acompanhá-lo na organização de seus deslocamentos.',
  sendMessage: 'Envie-nos uma mensagem',
  subject: 'Assunto',
  selectSubject: 'Selecione um assunto',
  quoteRequest: 'Solicitação de orçamento',
  serviceInfo: 'Informação sobre nossos serviços',
  complaint: 'Reclamação',
  partnership: 'Proposta de parceria',
  other: 'Outro',
  messageRequired: 'Mensagem',
  messageContactDescription: 'Descreva sua solicitação em detalhes...',
  sendMessageBtn: 'Enviar mensagem',
  ourCoordinates: 'Nossos Contatos',
  address: 'Endereço',
  telephone: 'Telefone',
  hours: 'Horários',
  officeHours: 'Escritório: 8h - 20h',
  followUs: 'Siga-nos',
  ourLocation: 'Nossa Localização',
  
  // Form Messages
  successMessage: 'Sua solicitação foi enviada com sucesso! Entraremos em contato em breve.',
  successContactMessage: 'Sua mensagem foi enviada com sucesso! Responderemos em breve.',
  errorMessage: 'Ocorreu um erro. Por favor, tente novamente ou entre em contato diretamente.',
  charactersLimit: 'caracteres',
  
  // Footer
  footerDescription: 'Seu parceiro de confiança para transporte turístico de luxo no Marrocos e no Canadá. Descubra nossos destinos com elegância e conforto.',
  ourServices: 'Nossos Serviços',
  copyright: '© 2024 HAFY TOURS. Todos os direitos reservados.',
  poweredBy: 'Powered by Readdy',
  
  // Common
  yearsExperience: 'Anos de experiência',
  includedInService: 'Incluído no serviço',
  reserveThisService: 'Reservar este serviço',
  chatOnWhatsApp: 'Conversar no WhatsApp',
  notAvailableYet: 'Ainda não disponível no momento',
  required: '*',
  placeholderName: 'Seu nome completo',
  placeholderEmail: 'seu@email.com',
  placeholderPhone: '+212 6XX XXX XXX',
  placeholderDeparture: 'Aeroporto, hotel, endereço...',
  placeholderDestination: 'Cidade, local turístico...'
};